import { Component, OnInit } from '@angular/core';
import {ModalExtended} from 'ngx-dynamic-modal';
import {VnaCallerIdService} from '../../services/vna-caller-id.service';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {Observable} from '../../../../../../../node_modules/rxjs';
import {VnaCampaignService} from '../../../vna-campaign/services/vna-campaign.service';

import * as _ from 'underscore';
import {AlertaService} from '../../../../../shared/services/alerta.service';
import {AuthService} from '../../../../../core/service/auth.service';

@Component({
  selector: 'app-caller-id-assign',
  templateUrl: './caller-id-assign.component.html',
  styleUrls: ['./caller-id-assign.component.scss']
})
export class CallerIdAssignComponent extends ModalExtended implements OnInit {

    data: Object;
    loading: boolean = false;
    form: FormGroup;

    constructor(private callerIdService: VnaCallerIdService, private fb: FormBuilder, private campaignService: VnaCampaignService, private alertaService: AlertaService, private auth: AuthService) {
        super();

        this.form = this.fb.group({
            'all_portal_campaigns' : new FormControl('0'),
            'campaigns' : new FormControl()
        });
    }

    requestAutocompleteCampaigns = (text: string): Observable<any> => {
        return this.campaignService.findByMatchName(text).map(
            (rows: Array<Object>) => {
                return rows.map((o) => {
                    return {
                        'value': o['pk'],
                        'display': o['name']
                    }
                })
            }
        );
    };

    onExit(): void {
        this.close();
    }

    toCampaigns(): void {
        if(!this.form.value.all_portal_campaigns && (!_.isArray(this.form.value.campaigns) || this.form.value.campaigns.length == 0)){
            this.alertaService.addAlert('warning', 'You must select at least one campaign');
            return;
        }

        this.loading = true;
        const pksCamps = (_.isArray(this.form.value.campaigns)) ? this.form.value.campaigns.map( (o) => { return o['value']; }) : [];
        this.callerIdService.callerIdToCampaigns(this.data['pk'], this.auth.getPkPortal(), pksCamps).subscribe(
            (r) => {
                this.loading = false;
                this.alertaService.addAlert('success', 'Caller id ' + this.data['number'] + ' assigned to ' + r.affected_rows + ' campaigns', '', 2000);
            }
        )

    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/caller-id/modals/caller-id-assign/caller-id-assign.component.ts